module.exports = __webpack_public_path__ + "img/poly-6.0ab0e1bc.png";